"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("_");

var _generalStore = _interopRequireDefault(require("general-store"));

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _PropertyGroupsAPI = require("crm_ui/property/api/PropertyGroupsAPI");

var state = {
  fetching: {},
  error: {},
  data: {}
};

function needsFetching(_ref) {
  var cache = _ref.cache,
      objectType = _ref.objectType,
      subjectId = _ref.subjectId;
  var fetching = state.fetching,
      data = state.data,
      error = state.error;
  return !cache || data[objectType + ":" + subjectId] === undefined && !fetching[objectType + ":" + subjectId] && !error[objectType + ":" + subjectId];
}

function get(_ref2, _ref3) {
  var STARTED = _ref2.STARTED;
  var objectType = _ref3.objectType,
      subjectId = _ref3.subjectId;
  var cache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var data = state.data;

  if (!objectType) {
    return data;
  }

  if (needsFetching({
    cache: cache,
    objectType: objectType,
    subjectId: subjectId
  })) {
    (0, _Dispatch.dispatchQueue)(STARTED, {
      cache: cache,
      objectType: objectType,
      subjectId: subjectId
    }).done();
  }

  return data[objectType + ":" + subjectId];
}

function handleStarted(_ref4, payload) {
  var fetch = _ref4.fetch,
      SUCCEEDED = _ref4.SUCCEEDED,
      FAILED = _ref4.FAILED;

  if (!needsFetching(payload)) {
    return;
  }

  var objectType = payload.objectType,
      subjectId = payload.subjectId;
  fetch(payload).then(function (data) {
    return (0, _Dispatch.dispatchImmediate)(SUCCEEDED, {
      objectType: objectType,
      subjectId: subjectId,
      data: data
    });
  }, function () {
    return (0, _Dispatch.dispatchImmediate)(FAILED, {
      objectType: objectType,
      subjectId: subjectId
    });
  }).done();
  state.fetching[objectType + ":" + subjectId] = true;
}

function handleSucceeded(_ref5) {
  var objectType = _ref5.objectType,
      subjectId = _ref5.subjectId,
      data = _ref5.data;
  delete state.fetching[objectType + ":" + subjectId];
  delete state.error[objectType + ":" + subjectId];
  state.data[objectType + ":" + subjectId] = data;
}

function handleFailed(_ref6) {
  var objectType = _ref6.objectType,
      subjectId = _ref6.subjectId;
  delete state.fetching[objectType + ":" + subjectId];
  delete state.error[objectType + ":" + subjectId];
}

function handleUpdated(_ref7) {
  var objectType = _ref7.objectType,
      subjectId = _ref7.subjectId,
      data = _ref7.data;
  state.data[objectType + ":" + subjectId] = data;
}

var context = {
  fetch: _PropertyGroupsAPI.fetch,
  STARTED: 'PROPERTY_GROUPS_FETCH_STARTED',
  SUCCEEDED: 'PROPERTY_GROUPS_FETCH_SUCCEEDED',
  FAILED: 'PROPERTY_GROUPS_FETCH_FAILED',
  UPDATED: 'PROPERTY_GROUPS_UPDATE_SUCCEEDED'
};

var _default = _generalStore.default.define().defineGet((0, _.partial)(get, context)).defineName('PropertyGroupsStore').defineResponseTo(context.STARTED, (0, _.partial)(handleStarted, context)).defineResponseTo(context.SUCCEEDED, handleSucceeded).defineResponseTo(context.FAILED, handleFailed).defineResponseTo(context.UPDATED, handleUpdated).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;